// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  PLPLabels,
  lblSortBy,
  lblSortAb,
  PLP_SORT_LABELS,
} from '@tcp/core/src/utils/labels/browse/PLP.labels';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import withStyles from '../../../../../../common/hoc/withStyles';
import SortSelectorStyle from '../SortSelector.style';
import CustomSelect from '../../CustomSelect/views';
import { getLocator } from '../../../../../../../utils';

export const FACETS_FIELD_KEY = {
  sort: 'sort',
};

class SortSelector extends React.PureComponent {
  render() {
    const {
      className,
      onChange,
      sortSelectOptions,
      selectTextOverride,
      onExpandCallback,
      expanded,
      hideTitle,
      isSortOpenModal,
      defaultPlaceholder,
      isFavoriteView,
      disableExpandStateChanges,
    } = this.props;

    return (
      <Field
        name={FACETS_FIELD_KEY.sort}
        component={CustomSelect}
        optionsMap={sortSelectOptions}
        title={
          hideTitle
            ? ''
            : getLabelFromCopyOrFromTranslation(`${PLP_SORT_LABELS}.${lblSortBy}`, PLPLabels)
        }
        placeholder={
          hideTitle
            ? ''
            : defaultPlaceholder ||
              getLabelFromCopyOrFromTranslation(`${PLP_SORT_LABELS}.${lblSortAb}`, PLPLabels)
        }
        allowMultipleSelections={false}
        className={className}
        onChange={onChange}
        onExpandCallback={onExpandCallback}
        expanded={expanded}
        selectTextOverride={selectTextOverride}
        type={FACETS_FIELD_KEY.sort}
        isSortOpenModal={isSortOpenModal}
        data-locator={getLocator('plp_sort_by_text')}
        isFavoriteView={isFavoriteView}
        disableExpandStateChanges={disableExpandStateChanges}
      />
    );
  }
}

SortSelector.propTypes = {
  className: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sortSelectOptions: PropTypes.shape([]).isRequired,
  selectTextOverride: PropTypes.string.isRequired,
  onExpandCallback: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  hideTitle: PropTypes.string.isRequired,
  isSortOpenModal: PropTypes.bool.isRequired,
  defaultPlaceholder: PropTypes.string.isRequired,
  isFavoriteView: PropTypes.bool.isRequired,
};

export default withStyles(SortSelector, SortSelectorStyle);
export { SortSelector as SortSelectorVanilla };
